export default function WorkflowHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-blue-50 pt-32 pb-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-block px-4 py-1.5 bg-teal-500/10 rounded-full mb-6">
            <span className="text-sm font-medium text-teal-600">专业咨询服务</span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            文档工作流程<br />咨询服务
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl">
            通过我们的专业咨询服务，优化您的文档管理流程，提升组织效率。我们帮助企业建立安全、高效、可扩展的文档工作流系统，实现数字化转型。
          </p>
          
          <div className="flex flex-wrap gap-4">
            <a 
              href="/contact" 
              className="inline-flex items-center px-8 py-3.5 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-all duration-200 shadow-lg shadow-teal-500/30 whitespace-nowrap cursor-pointer"
            >
              <span>立即咨询</span>
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </a>
            <a 
              href="#overview" 
              className="inline-flex items-center px-8 py-3.5 bg-white text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200 border border-gray-200 whitespace-nowrap cursor-pointer"
            >
              <span>了解更多</span>
              <i className="ri-arrow-down-line ml-2 text-lg"></i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
    </section>
  );
}
